export default __webpack_public_path__ + "static/media/ben.2af983b9.jpg";